<template>
  <div>
    <form
      id="donateForm"
      ref="donateForm"
      action="https://www.paypal.com/cgi-bin/webscr"
      method="post"
    >
      <input type="hidden" name="cmd" value="_donations" />
      <input type="hidden" name="business" :value="donateEmail" />
      <input type="hidden" name="notify_url" :value="donateURL" />
      <input
        v-if="donateOrg"
        type="hidden"
        name="item_name"
        :value="donateOrg"
      />
      <input v-else type="hidden" name="item_name" value="Donation" />
      <input v-if="amount" type="hidden" name="amount" :value="amount" />
      <input type="hidden" name="currency_code" :value="currency" />
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "PaypalDialog",
  props: ["currency", "amount"],
  data: function() {
    return {
      windowRef: null
    };
  },
  computed: {
    ...mapState("player", ["donateEmail", "donateOrg"]),
    ...mapGetters("player", ["donateURL"])
  },
  methods: {
    openPortal() {
      const width = 600;
      const height = 600;
      const y = window.outerHeight / 2 + window.screenY - height / 2;
      const x = window.outerWidth / 2 + window.screenX - width / 2;

      this.windowRef = window.open(
        "",
        "",
        "width=" + width + ",height=" + height + ",top=" + y + ",left=" + x
      );

      let form = this.$refs.donateForm;
      try {
        this.windowRef.document.body.appendChild(this.$el);
      } catch (e) {
        if (this.$el.outerHTML) {
          this.windowRef.document.body.innerHTML = this.$el.outerHTML;
          form = this.windowRef.document.getElementById("donateForm");
        }
      }
      form.submit();
      this.$emit("opened");
    }
  },
  mounted() {
    this.openPortal();
  }
};
</script>
